import { Box, Button, Grid, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function FormSkeleton({ withButton }: { withButton?: boolean }) {
  const { t } = useTranslation('web', { keyPrefix: 'components.paymentModal' });

  return (
    <Grid container spacing={3}>
      <Grid item sm={6}>
        <Skeleton variant="rounded" height={63} />
      </Grid>
      <Grid item sm={6}>
        <Skeleton variant="rounded" height={63} />
      </Grid>

      <Grid item sm={12} lg={6}>
        <Skeleton variant="text" />
        <Skeleton variant="rounded" height={44} />
      </Grid>

      <Grid item sm={6} lg={3}>
        <Skeleton variant="text" />
        <Skeleton variant="rounded" height={44} />
      </Grid>
      <Grid item sm={6} lg={3}>
        <Skeleton variant="text" />
        <Skeleton variant="rounded" height={44} />
      </Grid>

      <Grid item sm={12}>
        <Skeleton variant="text" />
        <Skeleton variant="rounded" height={44} />
      </Grid>

      <Grid item sm={12}>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        {withButton && (
          <Box paddingTop={6} display={'flex'} justifyContent={'start'} gap={3}>
            <Button variant="contained" disableElevation disabled>
              {t('subscribe')}
            </Button>
            <Button variant="outlined" disabled>
              {t('cancel')}
            </Button>
          </Box>
        )}
      </Grid>
    </Grid>
  );
}
